/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <b-modal
      v-model="visible"
      title=""
      size="xl"
      hide-footer
  >
    <CommonTableImportForm
        title="Import wyceny hurtowni"
        importType="wholesaler-pricing"
        mode="submit"
        :fieldDefinitions="fieldDefinitions"
        @onSaved="handleSuccess"
        :meta="importMeta"
        :identifierKeys="['bloz', 'ean', 'centralProductCartReference']"
    />
  </b-modal>
</template>

<script>
import CommonTableImportForm from "@/components/widgets/CommonTableImportForm.vue";
import { BModal } from "bootstrap-vue-next";

export default {
  name: "PackageOrderWholesalerPricingImportWrapper",
  components: { CommonTableImportForm, BModal },
  props: {
    orderGroupGuid: {
      type: String,
      required: true
    },
    selectedWholesalers: {
      type: Array,
      default: () => []
    }
  },
  emits: ['onImportSuccess', 'onClose'],
  data() {
    return {
      visible: false,
      fieldDefinitions: [
        { key: "wholesalerGuid", label: "GUID hurtowni", required: true, type: "string", description: "Identyfikator hurtowni (GUID)" },
        { key: "wholesalerName", label: "Nazwa hurtowni", required: false, type: "string" },
        { key: "bloz", label: "BLOZ", required: false, type: "string", description: "Kod BLOZ produktu" },
        { key: "ean", label: "EAN", required: false, type: "string", description: "Kod EAN produktu" },
        { key: "centralProductCartReference", label: "CKT", required: false, type: "string", description: "Centralny numer kartoteki (CKT)" },
        { key: "wholesalerProductReference", label: "Ref. produktu hurtowni", required: false, type: "string", description: "Referencja produktu u hurtownika" },
        { key: "offerPrice", label: "Cena ofertowa", required: false, type: "number", defaultValue: 0.0, description: "Cena netto z oferty hurtowni" },
        { key: "discount", label: "Rabat [%]", required: false, type: "number", defaultValue: 0.0, description: "Rabat procentowy" },
        { key: "notifications", label: "Uwagi", required: false, type: "string" }
      ]
    };
  },
  computed: {
    importMeta() {
      return {
        orderGroupGuid: this.orderGroupGuid,
        wholesalerGuids: this.selectedWholesalers.map(w => w.guid || w.id)
      };
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleSuccess() {
      this.visible = false;
      this.$emit('onImportSuccess');
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('onClose');
      }
    }
  }
};
</script>
